import { Box } from '@mui/system'
import {
  Divider,
  MenuItem,
} from '@mui/material'
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded'
import EditIcon from '@mui/icons-material/Edit'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import { useHistory } from 'react-router-dom'
import UseTranslation from '../../hooks/UseTranslation'
import SideButtonContainerWithModal from '../../components/Cards/helpers/SideButtonContainerWithModal'
import AppRoutes from '../../services/AppRoutes'

const CompanyActionBtn = ({
  data,
  status,
  statusButtonList,
  onStatusChangeClick,
  customStyle,
  onViewCompany,
}) => {
  const { t } = UseTranslation()
  const history = useHistory()

  const viewCompanyHandler = () => {
    onViewCompany?.(data)
  }

  const openEditCompanyPage = () => {
    history.push(
      AppRoutes.editCompany.replace(':companyId', String(data?.company?.id)),
    )
  }

  const changeStatusHandler = (item) => {
    if (onStatusChangeClick) {
      onStatusChangeClick(item, data)
    }
  }

  return (
    <>
       <Box
         sx={[styles.root, customStyle && customStyle]}
         onClick={(e) => e.stopPropagation()}
         onMouseDown={(e) => e.stopPropagation()}
       >
       <SideButtonContainerWithModal>
                    {onViewCompany && (
                      <MenuItem onClick={viewCompanyHandler} sx={styles.option}>
                        <VisibilityOutlinedIcon />
                        {t?.['View Company']}
                      </MenuItem>
                    )}
                    <MenuItem onClick={openEditCompanyPage} sx={styles.option}>
                      <EditIcon />
                      {t?.['Edit Company']}
                    </MenuItem>

                    <Divider sx={styles.optionDivider} />

                    <MenuItem disabled sx={styles.optionsTitle}>
                      {t?.['Change Status To']}
                    </MenuItem>
                    {statusButtonList
                      ?.filter((item) => item.title !== status?.title)
                      .map((item, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => changeStatusHandler(item)}
                          sx={styles.option}>
                          <FiberManualRecordRoundedIcon style={{ fill: `${item.color}` }} />
                          {t?.[item.title]}
                        </MenuItem>
                      ))}
                    </SideButtonContainerWithModal>
      </Box>
    </>
  )
}

const styles = {
  changeStatusContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: 'auto',
    padding: '10px',
    position: { xs: 'absolute', sm: 'unset' },
    top: { xs: '10px', sm: 'unset' },
    right: { xs: '0', sm: 'unset' },
  },
  moreActionsButton: {
    height: { xs: '30px', sm: '40px' },
    minWidth: { xs: '30px', sm: '40px' },
    borderRadius: '12px',
    border: 'solid 2px #e2e8ee',
    backgroundColor: '#f7f9fb',
    color: 'icon.primary',
    overflow: 'hidden',
    padding: '0',
  },
  changeStatusPopper: {
    minWidth: { xs: '100px', sm: '200px' },
    minHeight: { xs: '20px', sm: 'unset' },
    zIndex: '9',
  },
  popperPaper: {
    borderRadius: '12px',
  },
  optionDivider: {
    height: '1px',
    margin: { xs: '4px 8px', sm: '0px 8px' },
    borderRadius: '12px',
    backgroundColor: '#eaeaea',
  },
  option: {
    fontSize: { xs: '10px', sm: '14px' },
    padding: { xs: '0px 6px', sm: '6px 16px' },
    minHeight: { xs: '28px', sm: '36px' },
    color: '#000000',
    textTransform: 'capitalize',
    '& svg': {
      width: { xs: '0.5em', sm: '1em' },
    },
    '& .MuiSvgIcon-root': {
      marginRight: { xs: '5px', sm: '7px' },
    },
  },
  optionsTitle: {
    fontFamily: 'Avenir',
    fontSize: { xs: '10px', sm: '14px' },
    textTransform: 'capitalize',
    padding: { xs: '0px 6px', sm: '6px 16px' },
    minHeight: { xs: '28px', sm: '48px' },
  },
}

export default CompanyActionBtn
